export const REACT_APP_API_BASE_URL = "https://api.somado.me/api";
